/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { View, StyleSheet, type StyleProp, type ViewStyle } from 'react-native';
import { spacing } from '../theme/public-api';

type Props = {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  /** Por defecto `spacing.xs` (ej. medios de pago). Usar `spacing.sm` para filtros de stock. */
  gap?: number;
};

/** Fila de chips que hace wrap en varias líneas (evita scroll horizontal oculto). */
export const ChipWrapRow = ({ children, style, gap = spacing.xs }: Props) => (
  <View style={[styles.row, { gap }, style]}>{children}</View>
);

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
});
